import { useEffect, useState } from "react";

type IBreakpoints = {
  isMobile: boolean;
  isPortraitTablet: boolean;
  isLandscapeTablet: boolean;
  isSmallDesktop: boolean;
  isMediumDesktop: boolean;
  isLargeDesktop: boolean;
};

const getBreakpoints = (width: number): IBreakpoints => ({
  isMobile: width < 639,
  isPortraitTablet: width < 768,
  isLandscapeTablet: width < 1024,
  isSmallDesktop: width < 1280,
  isMediumDesktop: width < 1620,
  isLargeDesktop: width >= 1620,
});

export const useBreakpoints = () => {
  const [breakpoints, setBreakpoints] = useState<IBreakpoints>(() =>
    getBreakpoints(typeof window !== "undefined" ? window.innerWidth : 1440),
  );

  useEffect(() => {
    const handleResize = () => {
      setBreakpoints(getBreakpoints(window.innerWidth));
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return breakpoints;
};
